// extracted by mini-css-extract-plugin
export default {"unlog":"FavoriteProducts_unlog__nRNCr","card1":"FavoriteProducts_card1__B589F","card":"FavoriteProducts_card__u0jqa","empty":"FavoriteProducts_empty__zIc-a"};